import { render } from "./Pagination_principal.vue?vue&type=template&id=20aa6d12"
import script from "./Pagination_principal.vue?vue&type=script&lang=js"
export * from "./Pagination_principal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Alexandre-OlivierRenaud/formateurs-autorises/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__